<div class="alerts-accordion">
  <section
    class="alerts-accordion__section"
    [class.alerts-accordion__section--expanded]="expanded.scores"
  >
    <header
      class="alerts-accordion__header"
      role="button"
      tabindex="0"
      (click)="onHeaderClick('scores')"
      (keydown.enter)="onHeaderClick('scores')"
      (keydown.space)="onHeaderClick('scores')"
    >
      <mat-icon class="alerts-accordion__chevron">chevron_right</mat-icon>
      <div class="alerts-accordion__header-text">
        <div class="alerts-accordion__title-row">
          <span class="alerts-accordion__title">Score Alerts</span>
          <span class="alerts-accordion__count">
            {{ activeCount(scoreAlerts) }}/{{ scoreAlerts.length }}
          </span>
        </div>
        <p class="alerts-accordion__subtitle">
          Real-time notifications when score thresholds are crossed
        </p>
      </div>
      <button
        type="button"
        class="alerts-accordion__add"
        title="Create score alert"
        (click)="onAddClick($event, 'scores')"
      >
        <span class="alerts-accordion__add-plus">+</span>
        <span>Add</span>
      </button>
    </header>

    <div class="alerts-accordion__body" *ngIf="expanded.scores">
      <div
        *ngFor="let alert of scoreAlerts"
        class="alerts-accordion__row"
        [class.alerts-accordion__row--current]="alert.uid === currentAlertUid"
        (click)="onRowClick(alert)"
      >
        <span class="alerts-accordion__row-name">{{ alert.name }}</span>
        <div class="alerts-accordion__row-status">
          <span
            class="alerts-accordion__status"
            [class.alerts-accordion__status--active]="alert.active"
          >
            {{ alert.active ? 'Active' : 'Inactive' }}
          </span>
          <button
            type="button"
            role="switch"
            class="alerts-accordion__toggle"
            [class.alerts-accordion__toggle--on]="alert.active"
            [attr.aria-checked]="alert.active"
            (click)="onToggleClick($event, alert)"
          >
            <span class="alerts-accordion__toggle-thumb"></span>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section
    class="alerts-accordion__section"
    [class.alerts-accordion__section--expanded]="expanded.events"
  >
    <header
      class="alerts-accordion__header"
      role="button"
      tabindex="0"
      (click)="onHeaderClick('events')"
      (keydown.enter)="onHeaderClick('events')"
      (keydown.space)="onHeaderClick('events')"
    >
      <mat-icon class="alerts-accordion__chevron">chevron_right</mat-icon>
      <div class="alerts-accordion__header-text">
        <div class="alerts-accordion__title-row">
          <span class="alerts-accordion__title">Event Alerts</span>
          <span class="alerts-accordion__count">
            {{ activeCount(eventAlerts) }}/{{ eventAlerts.length }}
          </span>
        </div>
        <p class="alerts-accordion__subtitle">
          Daily digest when major events happen
        </p>
      </div>
      <button
        type="button"
        class="alerts-accordion__add"
        title="Create event alert"
        (click)="onAddClick($event, 'events')"
      >
        <span class="alerts-accordion__add-plus">+</span>
        <span>Add</span>
      </button>
    </header>

    <div class="alerts-accordion__body" *ngIf="expanded.events">
      <div
        *ngFor="let alert of eventAlerts"
        class="alerts-accordion__row"
        [class.alerts-accordion__row--current]="alert.uid === currentAlertUid"
        (click)="onRowClick(alert)"
      >
        <span class="alerts-accordion__row-name">{{ alert.name }}</span>
        <div class="alerts-accordion__row-status">
          <span
            class="alerts-accordion__status"
            [class.alerts-accordion__status--active]="alert.active"
          >
            {{ alert.active ? 'Active' : 'Inactive' }}
          </span>
          <button
            type="button"
            role="switch"
            class="alerts-accordion__toggle"
            [class.alerts-accordion__toggle--on]="alert.active"
            [attr.aria-checked]="alert.active"
            (click)="onToggleClick($event, alert)"
          >
            <span class="alerts-accordion__toggle-thumb"></span>
          </button>
        </div>
      </div>
    </div>
  </section>
</div>
